import {
  SanityBlockServiceLift,
  SanityBlockServiceLiftRow,
} from '~/types/sanityTypes';
import clsx from 'clsx';
import {ServiceCard} from '..';

export function BlockServiceLift({
  blockContent,
  className,
}: {
  blockContent: SanityBlockServiceLift;
  className?: string;
}) {
  const colorSchemeClass =
    blockContent.colorScheme === 'light'
      ? 'service-lift-light'
      : 'service-lift-dark';

  const blockStyles = clsx(colorSchemeClass);
  const styles = clsx('grid py-6 md:py-12', className);

  return (
    <>
      {blockContent.showTitle && (
        <div className="container">
          <h2
            className={`text-4xl leading-[1rem] md:text-5xl mt-12 md:leading-[2.8rem] text-outline-black text-transparent font-clash uppercase`}
          >
            Palvelut
          </h2>
        </div>
      )}
      <div className={blockStyles}>
        <div className="container">
          <div className={styles}>
            <div className="service-grid grid gap-[1px] bg-divider">
              {blockContent.rows &&
                blockContent.rows.map((row) => {
                  return (
                    <BlockServiceLiftRow key={row._key} rowContent={row} />
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function BlockServiceLiftRow({
  rowContent,
  className,
}: {
  rowContent: SanityBlockServiceLiftRow;
  className?: string;
}) {
  const length = rowContent.services.length;

  return (
    <div className="grid grid-cols-4 gap-[1px]">
      {rowContent.services.map((content, index) => {
        let className =
          'col-span-4 md:col-span-2 md:aspect-square lg:aspect-[3/2] xl:col-span-1 xl:aspect-square';

        if (length === 3) {
          if (index === 0) {
            className =
              'col-span-4 md:col-span-2 md:aspect-square lg:aspect-[3/2] xl:col-span-1 xl:aspect-square';
          }
          if (index === 1) {
            className =
              'col-span-4 md:col-span-2 md:aspect-square lg:aspect-[3/2] xl:aspect-[2/1]';
          }
          if (index === 2) {
            className =
              'col-span-4 md:aspect-[3/1] lg:aspect-[4/1] xl:col-span-1 xl:aspect-square';
          }
        }

        if (length === 2) {
          className =
            'col-span-4 md:col-span-2 md:aspect-square lg:col-span-2 lg:aspect-[2/1]';
        }

        if (length === 1) {
          // We got a fatty.
          className = 'col-span-4 md:aspect-[2/1] lg:aspect-[4/1]';
        }

        return (
          <ServiceCard
            key={content._id}
            serviceCard={content}
            className={className}
          />
        );
      })}
    </div>
  );
}
